import { useRollouts } from '../useRollouts';

export const useAiBriefAvailablity = () => {
    const { falcons_agencies_ai_brief } = useRollouts() ?? {};

    return !!falcons_agencies_ai_brief;
};
